import { render, staticRenderFns } from "./Tgr.vue?vue&type=template&id=1a1dc2ec&"
import script from "./Tgr.vue?vue&type=script&lang=ts&"
export * from "./Tgr.vue?vue&type=script&lang=ts&"
import style0 from "./Tgr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports